<template>
  <!-- import styles if needed -->
  <PageLoader class="mb-5 mt-5" v-if="isLoading"></PageLoader>
  <div v-if="is_loaded" v-show="!isLoading">
    <!-- import styles if needed -->

    <div v-if="is_loaded">
      <div id="current-user-wrapper">
        <snipp-current-user
          :campaign-id="campaignId"
          :user-status="user_status"
          @show-registration="showRegistration"
          @snipp-logout="handleSnippLogout"
          @show-confirmation="showConfirmation"
          @current-user="handleCurrentUser" custom-css="https://snippcheck.blob.core.windows.net/files/WK_Kellogg_Feeding_Reading_2007810/kellogs_overrides.css"
          :language="$t('Language')"
        ></snipp-current-user>
      </div>
      <div id="registration-wrapper" v-if="registration_enabled">
        <snipp-registration
          app-source="CampaignWidget"
          refresh-reload="true"
          :campaign-id="campaignId"
          :show-confirmation="show_confirmation" custom-css="https://snippcheck.blob.core.windows.net/files/WK_Kellogg_Feeding_Reading_2007810/kellogs_overrides.css"
          :is-logged-out="is_logged_out"
          @is-registered="handleIsRegistered"
           :language="$t('Language')"
        ></snipp-registration>
      </div>
      <div id="thanks-text" v-if="upload_enabled === 'upload_again'">
        <h1 class="text-uppercase mb-3">{{$t('IPEwidget.ThanksTitle')}}</h1>
        <p v-html="$t('IPEwidget.ThanksDesc')"></p>
      </div>
      <div id="upload-wrapper" v-if="upload_enabled">
        <div id="upload-original" v-if="upload_enabled !== 'upload_again'">
          <h2 class="text-center my-4">{{$t('IPEwidget.UploadReceiptTitle')}}</h2>
          <p v-html="$t('IPEwidget.ImageUploadDesc1')"></p>
          <p v-html="$t('IPEwidget.ImageUploadDesc2')"></p>
          <p class="my-4 text-center" v-html="$t('IPEwidget.ImageUplaodInstruction')"></p>
          <snipp-upload
            :campaign-id="campaignId"
            include-upload-button="true"
            @snipp-upload-result="handleSnippUploadResult"
            custom-css="https://snippcheck.blob.core.windows.net/files/WK_Kellogg_Feeding_Reading_2007810/kellogs_overrides.css"
            :language="$t('Language')"
          ></snipp-upload>
          <!-- <p class="my-4" v-html="$t('IPEwidget.ImageUplaodParticipatingProducts')"></p> -->
          <p class="my-4">
              <small v-html="$t('Home.ParticipatingProductLink')"></small>
            </p>
            <p>
              <small v-html="$t('Home.HavingTroubleLink')"></small>
            </p>
        </div>
        <div id="upload-again" v-if="upload_enabled === 'upload_again'">
          <snipp-upload
            :campaign-id="campaignId"
            include-upload-again-button="true"
            @snipp-upload-result="handleSnippUploadResult"
            custom-css="https://snippcheck.blob.core.windows.net/files/WK_Kellogg_Feeding_Reading_2007810/kellogs_overrides.css"
            :language="$t('Language')"
          ></snipp-upload>
          <p class="mt-3" v-html="$t('IPEwidget.ThanksVisitLink')"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageLoader from '../../../components/UI/PageLoader.vue';
export default {
  components: { PageLoader },
  props: ['campaignId'],
  emits: [],
  data() {
    return {
      ts: Date.now(),
      isLoading: true,
      is_loaded: false,
      is_logged_out: undefined,
      upload_enabled: undefined,
      registration_enabled: false,
      show_confirmation: undefined,
      user_status: undefined,
    };
  },
  methods: {
    showRegistration(confirmation) {
      if (this.upload_enabled) this.upload_enabled = undefined;
      if (confirmation) {
        this.show_confirmation = true;
      } else {
        this.show_confirmation = undefined;
      }
      this.registration_enabled = true;
    },
    showConfirmation() {
      this.showRegistration(true);
    },
    handleSnippLogout() {
      this.upload_enabled = undefined;
      this.is_logged_out = true;
      this.showRegistration();
    },
    handleIsRegistered() {
      this.user_status = Date.now();
      this.upload_enabled = 'upload';
      this.registration_enabled = false;
    },
    handleSnippUploadResult() {
      this.upload_enabled = 'upload_again';
    },
    handleCurrentUser() {
      this.registration_enabled = false;
      this.upload_enabled = 'upload';
    },
  },
  mounted() {
    this.is_loaded = true;
    setTimeout(() => (this.isLoading = false), 1500);
  },
};
</script>

<style scoped>
.wrapper {
  margin-top: 57px;
}
.color-red{color: #bf233a;}
#current-user-wrapper, #upload-wrapper {max-width: 70%; margin: 0 auto}
@media screen and (max-width: 575px) {
  #current-user-wrapper, #upload-wrapper {max-width: 100%; margin: 0 auto}
}

</style>
